export default __webpack_public_path__ + "images/b05082dec70ca9e01d657ac1943b31f6-fighting_martial_arts.webp";